import React from "react";

const textToHtml = (text) => {
  // Regex to detect URLs (both http and https)
  const urlPattern = /(http[s]?:\/\/[^\s<>"']+)/g;
  
  // Split the text by new lines and process each line
  const lines = text.split("\n");
  
  const htmlParts = lines.map((line, index) => {
    if (line.trim()) {
      // Replace URLs with anchor tags
      const formattedLine = line.replace(urlPattern, (url) => 
        `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
      );
      return `<p key=${index}>${formattedLine}</p>`;
    }
    return "";
  });

  return htmlParts.join(" <br>\n");
};

const TextRenderer = ({ text }) => {
  return <div dangerouslySetInnerHTML={{ __html: textToHtml(text) }} />;
};

export default TextRenderer;
